import React, { useState } from 'react';
import { Controller } from 'react-hook-form';
import Select from 'react-select';
import { get } from "lodash";
import { ExtendedProps, optionProp } from "types/index";
import addTeamIcon from 'assets/images/add-team.png';

interface CustomSelectProps {
    options: any[];
    defaultValue?: optionProp;
    selectedValue: any;
    extendedOption?: boolean;
    name: string;
    control: any;
    placeholder?: any;
    isSearchable?: boolean;
    onInputChange?: any;
    inputValue?: string;
    setInputValue?: any;
    styles?: any
    onChange: (selectedOption: any) => void;
}

const CustomDropdown: React.FC<CustomSelectProps> = ({
    options,
    defaultValue,
    selectedValue,
    extendedOption,
    onChange,
    control,
    styles,
    inputValue,
    isSearchable = false,
    placeholder,
    onInputChange,
    setInputValue,
    name,
    ...props
}) => {

    const extendedOptions: ExtendedProps[] = [
        ...options,
        { value: 'addNewTeam', label: 'Add new Team', image: addTeamIcon, },
    ];

    const customDropdownStyle = {
        singleValue: (styles: any) => ({
            ...styles,
            color: "#344054",
        }),
        valueContainer: (styles: any) => ({
            ...styles,
            backgroundColor: "#f9fafb",
            padding: "0px",
            fontSize: "14px",
            cursor: "pointer",
        }),
        control: (styles: any) => ({
            ...styles,
            backgroundColor: "#f9fafb",
            boxShadow: "none",
            padding: "8px 12px",
            border: "none",
            borderRadius: "8px",
            cursor: "pointer",
        }),
        indicatorContainer: (styles: any) => ({
            ...styles,
            padding: "0px 0px",
        }),
        indicatorSeparator: (styles: any) => ({ ...styles, display: "none" }),
        dropdownIndicator: (styles: any) => ({
            ...styles,
            color: "#85888E",
            cursor: "pointer",
            "&:hover": { color: "#85888E" },
            paddingRight: "0px",
        }),
        menu: (styles: any) => ({
            ...styles,
            left: "0",
            boxShadow: "0px 2px 4px -2px rgba(16, 24, 40, 0.06), 0px 4px 8px -2px rgba(16, 24, 40, 0.10)",
            backgroundColor: "#fff",
            borderRadius: "12px",
            margin: "0px",
            overflow: "hidden"
        }),
        menuList: (styles: any) => ({
            ...styles,
            backgroundColor: "#fff",
            maxHeight: "192px",
            padding: "4px 4px"
        }),
        option: (styles: any, { isFocused }: any) => ({
            ...styles,
            cursor: "pointer",
            fontSize: "14px",
            fontWeight: "400",
            color: "#344054",
            padding: "6px 6px 6px 6px",
            borderRadius: "12px",
            marginBottom: "16px",
            backgroundColor: isFocused ? "" : "",
			"&:active": { color: "#1e0af5", backgroundColor: '#fff' },
			"&:hover": { color: "#1e0af5" },
        }),
        placeholder: (styles: any) => ({
            ...styles,
            fontWeight: "500",
            fontSize: "16px",
        }),
    };

    return (
        <div>
            <Controller
                name={name}
                control={control}
                defaultValue={defaultValue}
                render={({ field, fieldState }) => (
                    <>
                        <Select
                            {...field}
                            placeholder={placeholder}
                            className='react-select-wrapper'
                            classNamePrefix="react-select"
                            value={selectedValue}
							// menuIsOpen={true}
                            onChange={(value) => {
                                field.onChange(value);
                                onChange(value);
                            }}
                            options={extendedOption ? extendedOptions : options}
                            styles={customDropdownStyle}
                            isSearchable={isSearchable}
                            formatOptionLabel={(value: optionProp) => (
                                <div className="flex items-center">
                                    {value?.image && <img className="w-8 h-8 object-cover rounded relative z-10" src={value.image} />}
                                    {value.label &&<div className="ml-2.5 truncate font-interMedium text-base dropdown-value" title={value.label}>{value.label}</div>}
                                </div>
                            )}
                            {...props}
                        />
                        {get(fieldState, "error.label.message") && <p className="text-red-600">{get(fieldState, "error.label.message")}</p>}
                        {get(fieldState, "error.message") && <p className="text-red-600">{get(fieldState, "error.message")}</p>}
                    </>

                )}
            />

        </div>
    );
};

export default CustomDropdown;
